import { useEffect, useState } from 'react';
import { api } from '../../lib/api.js';
import { useAuth } from '../../context/AuthContext.jsx';
import { markOpenedBriefToday } from '../../lib/dailyLanding.js';
import WebBrief from '../../components/brief/WebBrief.jsx';

export default function TodaysBrief() {
  const { isAuthenticated } = useAuth();
  const [state, setState] = useState({ status: 'loading', edition: null, error: null });

  useEffect(() => {
    if (isAuthenticated) markOpenedBriefToday();
  }, [isAuthenticated]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await api.get('/editions/today');
        if (!cancelled) setState({ status: 'ready', edition: data?.edition || null, error: null });
      } catch (err) {
        if (!cancelled) setState({ status: 'error', edition: null, error: err.message });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const { status, edition, error } = state;
  const loaded = status === 'ready';
  const hasArticles = (edition?.articles || []).length > 0;
  return (
    <div className="max-w-page mx-auto px-4 sm:px-6 py-8">
      {status === 'loading' && (
        <p className="text-[13px] text-hxd-muted italic text-center">Loading today&apos;s brief…</p>
      )}

      {status === 'error' && (
        <p className="text-[13px] text-red-600 text-center">
          Couldn&apos;t load today&apos;s brief: {error}
        </p>
      )}

      {loaded && !edition && (
        <div className="w-full text-center py-12">
          <p className="font-display text-[13px] font-bold tracking-display-md uppercase text-black m-0">
            No brief available yet
          </p>
          <p className="text-[14px] text-hxd-muted mt-3 leading-relaxed">
            Today&apos;s edition hasn&apos;t been published. Check back after the morning send
            {isAuthenticated ? '.' : ', or sign in as an editor to preview the draft.'}
          </p>
          {!isAuthenticated && (
            <p className="mt-4">
              <a href="/login" className="text-hxd-orange font-semibold hover:underline">
                Sign in →
              </a>
            </p>
          )}
        </div>
      )}

      {loaded && edition && (
        <>
          {!hasArticles && (
            <p className="text-[15px] text-hxd-muted italic text-center w-full mb-6">
              No articles to show yet — today&apos;s edition has not been reviewed.
            </p>
          )}
          <WebBrief edition={edition} briefPath="/today" ready />
        </>
      )}
    </div>
  );
}
